module.exports = __webpack_public_path__ + "static/main_imgOg-ee4a5fab2ea318026a89bcf992ee7a8b.jpg";